/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateStringWithoutTime } from 'utils';
import type { TRootState } from './store';

type TDentistsState = {
  page: number | undefined;
  perPage: number | undefined;
  status: string;
  searchStr: string;
  filter?: any;
  assignRecord?: any;
};

const initialState: TDentistsState = {
  page: 1,
  perPage: 10,
  status: 'all',
  searchStr: '',
  assignRecord: {},
  filter: '',
};

const slice = createSlice({
  name: 'dentists',
  initialState: { ...initialState },
  reducers: {
    setPginationData: (
      state,
      { payload: { page, perPage } }: PayloadAction<{ page: number | undefined; perPage: number | undefined }>,
    ) => {
      state.page = page;
      state.perPage = perPage;
    },
    setSelectedStatus: (state, { payload: { status } }: PayloadAction<{ status: string }>) => {
      state.status = status;
    },
    setSearchStr: (state, { payload: { q } }: PayloadAction<{ q: string }>) => {
      state.page = 1;
      state.searchStr = q;
    },
    setSelectedFilter: (state, { payload: filter }: PayloadAction<any>) => {
      let filterData: string = '';
      if (filter?.searchBy === 'practice') {
        if (filter?.practiceName) filterData += `&practiceName=${filter.practiceName}`;
        if (filter?.practiceId) filterData += `&practiceId=${filter.practiceId}`;
        if (filter?.practiceAddress) filterData += `&practiceAddress=${filter.practiceAddress}`;
        if (filter?.practiceEmail) filterData += `&practiceEmail=${filter.practiceEmail}`;
        if (filter?.adminName) filterData += `&adminName=${filter.adminName}`;
      } else if (filter?.searchBy === 'dentist') {
        if (filter?.category) filterData += `&category=${filter.category}`;
        if (filter?.dentistGdcNumber) filterData += `&gdcNumber=${filter.dentistGdcNumber}`;
        if (filter?.dentistReferralCode) filterData += `&referralCode=${filter.dentistReferralCode}`;
        if (filter?.onBoardingDate?.length === 2)
          filterData += `&fromDate=${getDateStringWithoutTime(
            filter.onBoardingDate?.[0],
          )}&toDate=${getDateStringWithoutTime(filter.onBoardingDate?.[1])}`;
        if (filter?.dentistEmail) filterData += `&dentistEmail=${filter.dentistEmail}`;
        if (filter?.dentistName) filterData += `&dentistName=${filter.dentistName}`;
        // for education content assign dentist
        if (filter?.country && filter?.country.length > 0) {
          filterData += `&country=${filter.country}`;
        }
        if (filter?.minCases) filterData += `&minCases=${filter.minCases}`;
        if (filter?.maxCases) filterData += `&maxCases=${filter.maxCases}`;
        if (filter?.group) filterData += `&group=${filter.group}`;
      }
      state.filter = filterData;
    },
    reset: () => ({ ...initialState }),
  },
});

export const { setPginationData, setSelectedStatus, setSearchStr, setSelectedFilter, reset } = slice.actions;

export default slice.reducer;

export const selectCurrentPage = (state: TRootState) => state.dentists.page;
export const selectPageSize = (state: TRootState) => state.dentists.perPage;
export const selectStatus = (state: TRootState) => state.dentists.status;
export const selectSearchStr = (state: TRootState) => state.dentists.searchStr;
export const selectFilter = (state: TRootState) => state.dentists.filter;
